/**
 * Do not edit directly
 * Generated on Wed, 30 Aug 2023 11:19:23 GMT
 */

export const SDS_SIZE_BORDER_XSMALL = "0.03125rem"; // X-small border size
export const SDS_SIZE_BORDER_SMALL = "0.0625rem"; // Small border size
export const SDS_SIZE_BORDER_MEDIUM = "0.09375rem"; // Medium border size
export const SDS_SIZE_BORDER_LARGE = "0.125rem"; // Large border size
export const SDS_SIZE_BORDER_XLARGE = "0.25rem"; // X-large border size
export const SDS_SIZE_BORDER_RADIUS_NONE = "0"; // No border radius
export const SDS_SIZE_BORDER_RADIUS_XXXXSMALL = "0.125rem"; // XXXX-small border radius
export const SDS_SIZE_BORDER_RADIUS_XXXSMALL = "0.25rem"; // XXX-small border radius
export const SDS_SIZE_BORDER_RADIUS_XXSMALL = "0.375rem"; // XX-small border radius
export const SDS_SIZE_BORDER_RADIUS_XSMALL = "0.5rem"; // X-small border radius
export const SDS_SIZE_BORDER_RADIUS_SMALL = "0.625rem"; // Small border radius
export const SDS_SIZE_BORDER_RADIUS_MEDIUM = "0.75rem"; // Medium border radius
export const SDS_SIZE_BORDER_RADIUS_LARGE = "0.875rem"; // Large border radius
export const SDS_SIZE_BORDER_RADIUS_XLARGE = "1rem"; // X-Large border radius
export const SDS_SIZE_BORDER_RADIUS_XXLARGE = "1.125rem"; // XX-Large border radius
export const SDS_SIZE_BORDER_RADIUS_XXXLARGE = "1.25rem"; // XXX-Large border radius
export const SDS_SIZE_BORDER_RADIUS_XXXXLARGE = "1.5rem"; // XXXX-Large border radius
export const SDS_SIZE_BORDER_RADIUS_XXXXXLARGE = "1.875rem"; // XXXXX-Large border radius
export const SDS_SIZE_BORDER_RADIUS_XXXXXXLARGE = "2.25rem"; // XXXXXX-Large border radius
export const SDS_SIZE_BORDER_RADIUS_XXXXXXXLARGE = "2.5rem"; // XXXXXXX-Large border radius
export const SDS_SIZE_BORDER_RADIUS_CIRCLE = "1000rem"; // Circle border radius
export const SDS_SIZE_XXXXXXXXSMALL = "0.03125rem"; // XXXXXXXX-small size
export const SDS_SIZE_XXXXXXXSMALL = "0.0625rem"; // XXXXXXX-small size
export const SDS_SIZE_XXXXXXSMALL = "0.09375rem"; // XXXXXX-small size
export const SDS_SIZE_XXXXXSMALL = "0.125rem"; // XXXXX-small size
export const SDS_SIZE_XXXXSMALL = "0.25rem"; // XXXX-small size
export const SDS_SIZE_XXXSMALL = "0.5rem"; // XXX-small size
export const SDS_SIZE_XXSMALL = "0.75rem"; // XX-small size
export const SDS_SIZE_XSMALL = "1rem"; // X-small size
export const SDS_SIZE_SMALL = "1.25rem"; // Small size
export const SDS_SIZE_MEDIUM = "1.5rem"; // Medium size
export const SDS_SIZE_LARGE = "1.75rem"; // Large size
export const SDS_SIZE_XLARGE = "2rem"; // X-large size
export const SDS_SIZE_XXLARGE = "2.25rem"; // XX-large size
export const SDS_SIZE_XXXLARGE = "2.5rem"; // XXX-large size
export const SDS_SIZE_XXXXLARGE = "3rem"; // XXXX-large size
export const SDS_SIZE_XXXXXLARGE = "3.75rem"; // XXXXX-large size
export const SDS_SIZE_XXXXXXLARGE = "4.5rem"; // XXXXXX-large size
export const SDS_SIZE_XXXXXXXLARGE = "5rem"; // XXXXXXX-large size
